<template>
	<div>
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />

		<div class="page-error padding-top-20 padding-bottom-100">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 text-center margin-bottom-30">
						<h1>4<i class="fa fa-frown-o" aria-hidden="true"></i>4</h1>
						<span>{{ $t('Sentence.PageNotFoundTitle') }}</span>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12 text-center">
						<h4 class="margin-bottom-70">
							{{ $t('Sentence.PageNotFoundText1') }}<br />
							<em>{{ $t('Sentence.PageNotFoundText2') }}</em>
						</h4>
					</div>
				</div>

				<back-to-home v-once />
			</div>
		</div>
	</div>
</template>

<script>
import BackToHome from '@/components/atoms/BackToHome'
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'

export default {
	name: 'PageNotFound',
	components: {
		BackToHome,
		PageTitle,
	},
	mixins: [PageInfo],
}
</script>



// WEBPACK FOOTER //
// src/views/PageNotFound.vue